module.exports = __webpack_public_path__ + "img/5.37524e78.svg";